import Vue from 'vue'
export default new Vue()



// WEBPACK FOOTER //
// ./src/common/js/eventBus.js